module.exports = __webpack_public_path__ + "static/noImpactBuilding-8eee7545e35ba7709d8c55eabb4c2668.svg";